import Banner from "./Banner";
import { useEffect } from "react";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import InputField from "shared/InputField";
import WebLayout from "layout/webLayout.js";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import { TKIconSpinner } from "assets/images/svgs";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { makeProjectDonation } from "appState/donation/donationSlice";
import { pickupValidationSchema } from "validation/DonateItem/pickupSchema";
import { dropoffValidationSchema } from "validation/DonateItem/dropoffSchema";

const DonateInfo = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const dispatch = useDispatch();
  const { isLoading } = useSelector((state) => state.donation);

  const { donor } = useSelector((state) => state.auth);

  const formik = useFormik({
    initialValues: {
      fullName: "",
      address: "",
    },
    validationSchema:
      state.delivery_method === "pickup"
        ? pickupValidationSchema
        : dropoffValidationSchema,
    onSubmit: (values) => {
      const body =
        state.delivery_method === "pickup"
          ? {
              fullName: values.fullName,
              address: values.address,
            }
          : {
              fullName: values.fullName,
            };
      if (state.delivery_method === "pickup") {
        dispatch(
          makeProjectDonation(
            donor?.donor?._id
              ? {
                  ...state,
                  donor: donor?.donor?._id,
                  fullName: body.fullName,
                  address: body.address,
                  type: "item",
                  payment_method: "none",
                  amount: "",
                  email: "",
                }
              : {
                  ...state,
                  fullName: body.fullName,
                  address: body.address,
                  type: "item",
                  payment_method: "none",
                  amount: "",
                  email: "",
                }
          )
        ).then((data) => {
          if (data?.payload?.status === 200) {
            toast.success("Items donated successfully!");
            let path = "/donate-items/success";
            navigate(path);
          }
        });
      } else {
        dispatch(
          makeProjectDonation(
            donor?.donor?._id
              ? {
                  ...state,
                  donor: donor?.donor?._id,
                  fullName: body.fullName,
                  type: "item",
                  payment_method: "none",
                  address: "none",
                  amount: "",
                  email: "",
                }
              : {
                  ...state,
                  fullName: body.fullName,
                  type: "item",
                  payment_method: "none",
                  address: "none",
                  amount: "",
                  email: "",
                }
          )
        ).then((data) => {
          if (data?.payload?.status === 200) {
            toast.success("Items donated successfully!");
            let path = "/donate-items/success";
            navigate(path);
          }
        });
      }
    },
  });

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <WebLayout>
      <Banner />
      <div className="flex justify-center items-center">
        <div className="w-4/5 md:w-3/5 py-24 flex justify-center items-center">
          <div className="flex flex-col gap-4 justify-center items-center">
            <p className="text-[#213874] text-[24px] font-bold text-center">
              {`We need your ${
                state.delivery_method === "pickup" ? "pick up" : ""
              } info`}
            </p>
            <p className="text-[#7A7A7A] text-[16px] text-center">
              {state.delivery_method === "pickup"
                ? "We need to know where and when to pick up the donations from you."
                : "Please fill in your details and a member of our team will reach out."}
            </p>
            <form className="w-full" onSubmit={formik.handleSubmit}>
              <div className="flex flex-col gap-4">
                <div className="flex flex-col gap-2">
                  <label className="text-[14px] font-normal text-[#213874]">
                    Full Name
                  </label>
                  <InputField
                    className="border !min-h-[45px] !border-[#213874] !rounded-3xl"
                    type="text"
                    name="fullName"
                    id="fullName"
                    placeholder="First name & Last name"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.fullName}
                  />
                  {formik.touched.fullName && formik.errors.fullName ? (
                    <p className="text-red-500 text-xs mt-[8px] w-[300px] md:w-[424px]">
                      {formik.errors.fullName}
                    </p>
                  ) : null}
                </div>
                <div className="flex flex-col gap-2">
                  <label className="text-[14px] font-normal text-[#213874]">
                    Contact Number
                  </label>
                  <PhoneInput
                    placeholder="+2349012345678"
                    country={"ng"}
                    onlyCountries={["ng"]}
                    onBlur={formik.handleBlur}
                    containerClass="donateInfoPhoneInput"
                    inputProps={{
                      name: "contactNumber",
                      required: true,
                      autoFocus: true,
                    }}
                  />
                  {formik.touched.phone && formik.errors.phone ? (
                    <p className="text-red-500 text-xs mt-[8px] w-[300px] md:w-[424px]">
                      {formik.errors.phone}
                    </p>
                  ) : null}
                </div>
                {state.delivery_method === "pickup" ? (
                  <>
                    <div className="flex flex-col gap-2">
                      <label className="text-[14px] font-normal text-[#213874]">
                        Pick-up Address
                      </label>
                      <InputField
                        className="border !min-h-[45px] !border-[#213874] !rounded-3xl"
                        type="text"
                        name="address"
                        placeholder="Enter pickup address"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.address}
                      />
                      {formik.touched.address && formik.errors.address ? (
                        <p className="text-red-500 text-xs mt-[8px] w-[300px] md:w-[424px]">
                          {formik.errors.address}
                        </p>
                      ) : null}
                    </div>
                    <div className="flex flex-col gap-2">
                      <label className="text-[14px] font-normal text-[#213874]">
                        Date for Pick-up
                      </label>
                      <InputField
                        className="border !min-h-[45px] !border-[#213874] !rounded-3xl"
                        type="date"
                        name="pickupDate"
                        placeholder="Enter pickup date"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.pickupDate}
                      />
                      {formik.touched.pickupDate && formik.errors.pickupDate ? (
                        <p className="text-red-500 text-xs mt-[8px] w-[300px] md:w-[424px]">
                          {formik.errors.pickupDate}
                        </p>
                      ) : null}
                    </div>
                  </>
                ) : null}
                {state.delivery_method !== "pickup" ? (
                  <div className="flex flex-col gap-2">
                    <label className="text-[14px] font-normal text-[#213874]">
                      Email
                    </label>
                    <InputField
                      className="border !min-h-[45px] !border-[#213874] !rounded-3xl"
                      type="text"
                      name="email"
                      placeholder="info@truekeepers.com"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.email}
                    />
                    {formik.touched.email && formik.errors.email ? (
                      <p className="text-red-500 text-xs mt-[8px] w-[300px] md:w-[424px]">
                        {formik.errors.email}
                      </p>
                    ) : null}
                  </div>
                ) : null}
                <div className="my-4">
                  <button
                    className="w-full h-[50px] flex justify-center items-center rounded-3xl bg-[#213874] hover:bg-[#182d62] px-4 py-2"
                    type="submit"
                  >
                    <p className="text-white">
                      {isLoading ? <TKIconSpinner /> : "Proceed"}
                    </p>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </WebLayout>
  );
};

export default DonateInfo;
